const getDisplayValue = (propToDisplay, properties) => {
  const [matchingProperty] = Object.keys(properties).filter(property => property === propToDisplay);
  return matchingProperty ? properties[matchingProperty].unit : null;
};

export default getDisplayValue;
